module.exports = __webpack_public_path__ + "static/img/scenes_icon_superman.a928f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenes_icon_superman.png
// module id = 7Hau
// module chunks = 1